import { Component, Input } from '@angular/core';

/** Bereich lädt (Seite, Karte, Dialogkörper) — rendert `app-orbi-loader`.
 *  Ladezustände-Regel: CLAUDE.md Regel 19, design.md §5 „Ladezustände". */
@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrl: './page-loader.component.scss'
})
export class PageLoaderComponent {
  /** Optional: was gerade passiert, schon übersetzt. */
  @Input() label: string | null = null;
}
